module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Claus_480x480.fa222dfd.mp4";